import { createContext, useContext } from 'react'
import type { EdgeFades } from './fitToContent'
import type { PannableCanvasTransform } from './usePannableCanvasState'

type CanvasPoint = {
  x: number
  y: number
}

export type PannableCanvasContextValue = {
  transform: PannableCanvasTransform
  viewportRect: DOMRect | null
  overlayEl: HTMLElement | null
  worldToScreen: (worldX: number, worldY: number) => CanvasPoint
  screenToWorld: (screenX: number, screenY: number) => CanvasPoint
  worldToViewport: (worldX: number, worldY: number) => CanvasPoint
  viewportToWorld: (viewportX: number, viewportY: number) => CanvasPoint
  edgeFades?: EdgeFades
}

const DEFAULT_TRANSFORM: PannableCanvasTransform = { x: 0, y: 0, zoom: 1 }

const defaultContextValue: PannableCanvasContextValue = {
  transform: DEFAULT_TRANSFORM,
  viewportRect: null,
  overlayEl: null,
  worldToScreen: (worldX, worldY) => ({ x: worldX, y: worldY }),
  screenToWorld: (screenX, screenY) => ({ x: screenX, y: screenY }),
  worldToViewport: (worldX, worldY) => ({ x: worldX, y: worldY }),
  viewportToWorld: (viewportX, viewportY) => ({ x: viewportX, y: viewportY }),
}

export const PannableCanvasContext = createContext<PannableCanvasContextValue>(defaultContextValue)

export const usePannableCanvasContext = () => useContext(PannableCanvasContext)
